import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { serviceCategories } from '../mock';

const DetailedServices = () => {
  return (
    <section className="bg-ivory">
      {serviceCategories.map((s, idx) => {
        const reverse = idx % 2 === 1;
        return (
          <div
            key={s.id}
            id={s.id}
            className={`relative py-24 lg:py-32 ${idx % 2 === 0 ? 'bg-ivory' : 'bg-paper'} border-t border-line`}
          >
            <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
              <div
                className={`grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center ${
                  reverse ? 'lg:[&>*:first-child]:order-2' : ''
                }`}
              >
                {/* Image */}
                <div className="lg:col-span-5 relative">
                  <div className="img-zoom aspect-[4/5] relative">
                    <img src={s.image} alt={s.title} className="w-full h-full object-cover" />
                    <div className="absolute inset-0 border border-ivory/20"></div>
                  </div>
                  <div
                    className={`absolute ${
                      reverse ? '-bottom-6 -right-6' : '-bottom-6 -left-6'
                    } bg-ivory px-5 py-3 border-l-2 border-gold`}
                  >
                    <span className="font-serif-display text-3xl text-ink">{s.number}</span>
                    <span className="font-mono-label text-gold-dark ml-3">{s.badge}</span>
                  </div>
                </div>

                {/* Content */}
                <div className="lg:col-span-7">
                  <div className="flex items-center gap-4 mb-5">
                    <span className="gold-divider"></span>
                    <span className="font-mono-label text-gold-dark">{s.badge}</span>
                  </div>
                  <h3 className="font-serif-display text-3xl lg:text-[2.6rem] leading-[1.08] text-ink">
                    {s.headline}
                  </h3>
                  <p className="font-sans-body text-lg text-muted-kmh leading-relaxed mt-6 max-w-2xl">
                    {s.description}
                  </p>

                  {/* Facts (only for PoSH) */}
                  {s.facts && (
                    <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6">
                      {s.facts.map((f) => (
                        <div key={f.title} className="border-t border-gold/40 pt-5">
                          <p className="font-serif-display text-lg text-ink">{f.title}</p>
                          <p className="font-sans-body text-xs text-muted-kmh leading-relaxed mt-2">{f.text}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Offerings */}
                  <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-6">
                    {s.offerings.map((o, oi) => (
                      <div key={oi} className="flex gap-4 group">
                        <span className="flex-shrink-0 w-8 h-8 rounded-full border border-gold/40 flex items-center justify-center mt-1 group-hover:bg-gold/10">
                          <Check className="w-3.5 h-3.5 text-gold-dark" strokeWidth={2} />
                        </span>
                        <div>
                          <p className="font-serif-display text-lg text-ink leading-snug">{o.title}</p>
                          <p className="font-sans-body text-sm text-muted-kmh leading-relaxed mt-1">{o.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <a
                    href="#contact"
                    className="inline-flex items-center gap-3 mt-12 font-mono-label text-ink hover:text-gold-dark group"
                  >
                    <span>Engage Our Team</span>
                    <span className="w-10 h-10 rounded-full border border-line group-hover:border-gold flex items-center justify-center">
                      <ArrowRight className="w-4 h-4" />
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default DetailedServices;
